<template>
  <main class="app_layout">
    <div
        class="app_layout-content"
        :class="{ 'app_layout-content--has-nav': isNavVisible }">
      <slot></slot>
    </div>

    <VNav v-if="isNavVisible" />
  </main>
</template>

<script>
import VNav from "@/components/VNav.vue";
import i18n from "@/i18n";

export default {
  name: "VAppLayout",
  components: {VNav},
  props: {
    isNavVisible: {type: Boolean, default: true}
  },
  mounted() {
    i18n.locale = this.$store.getters.getPrefLangCode;
  }
}
</script>

<style lang="scss" scoped>
.app_layout {
  box-sizing: border-box;
  /* min- (not fixed) height: the layout grows with content so the DOCUMENT is
     the scroll container. iOS Safari only collapses its toolbars (and lets the
     page run edge-to-edge under them) when the document itself scrolls — an
     inner overflow:auto scroller keeps the browser chrome permanently expanded.
     Viewport units (not %) — html/body/#app have no height on purpose. */
  min-height: 100vh;
  min-height: 100svh;
  display: flex;
  flex-direction: column;
  background: var(--surface-page);
}

.app_layout-content {
  flex: 1 1 auto;

  /* Leave room for the floating glass nav so it never covers content. The dock
     itself occupies ~80px from the bottom (float-gap + dock height); the extra
     32px gives the last item comfortable breathing room above the nav. */
  &--has-nav {
    padding-bottom: calc(var(--nav-height) + var(--nav-float-gap) * 2 + var(--safe-bottom) + 32px);
  }
}
</style>
